import React from 'react';
import PropTypes from 'prop-types';

import { StyledAltTag } from './StyledComponents';

const AltTag = (props) => {
    const {
        appearance,
        children,
        size,
    } = props;

    return (
        <StyledAltTag
            className="AltTag"
            appearance={appearance}
            size={size}
        >
            {children}
        </StyledAltTag>
    );
};

AltTag.propTypes = {
    appearance: PropTypes.string,
    children: PropTypes.node.isRequired,
    size: PropTypes.string,
};

AltTag.defaultProps = {
    appearance: 'gray',
    size: 'sm',
};

export default AltTag;
